import type { SVGProps } from 'react'
const LineImageAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M4.75 4h14.5A2.755 2.755 0 0 1 22 6.75v10.5A2.755 2.755 0 0 1 19.25 20H4.75A2.755 2.755 0 0 1 2 17.25V6.75A2.755 2.755 0 0 1 4.75 4m0 1.5c-.69 0-1.25.56-1.25 1.25v10.505c0 .455.245.85.615 1.07l5.25-5.25a1.26 1.26 0 0 1 1.77 0L12.5 14.44l4.115-4.115a1.26 1.26 0 0 1 1.77 0L20.5 12.44V6.75c0-.69-.56-1.25-1.25-1.25zm1.31 13h13.19c.69 0 1.25-.56 1.25-1.25v-2.69l-3-3-5 5-2.25-2.25zm3.94-9a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1 5 0m-1.5 0c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineImageAlt }
